/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isNone as r } from "./maybe.js";
import { eachAlways as o, resolve as t, throwIfAbortError as e } from "./promiseUtils.js";

function n(r, t, e) {
  return o(r.map(function (r, o) {
    return t.apply(e, [r, o]);
  }));
}

function u(r, t, e) {
  return o(r.map(function (r, o) {
    return t.apply(e, [r, o]);
  })).then(function (r) {
    return r.map(function (r) {
      return r.value;
    });
  });
}

function a(o) {
  return r(o) ? t() : o.then(function (r) {
    return {
      ok: !0,
      value: r
    };
  }).catch(function (r) {
    return {
      ok: !1,
      error: r
    };
  });
}

function p(r) {
  return r.then(function (r) {
    return {
      ok: !0,
      value: r
    };
  }).catch(function (r) {
    return e(r), {
      ok: !1,
      error: r
    };
  });
}

function i(r) {
  if (!0 === r.ok) return r.value;
  throw r.error;
}

export { i as assertResult, n as forEach, u as map, a as result, p as resultOrAbort };